import { useEffect, useState } from "react";
import { Alert, Grid, Card, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import { get, postFile } from "utils/WebService";
import { errorAlert, successAlert, warningAlert } from "utils/Functions";
import { useMaterialUIController } from "context";
import { ESCURO } from "assets/coresTema";

const escaparHtml = (texto) => String(texto ?? "")
    .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

export default function BatimentoGetnet() {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const [loading, setLoading] = useState(false);
    // Pasta do Batimento (Parametrização do Sistema > Pastas e Arquivos): com ela, o arquivo é salvo lá e não é baixado.
    // undefined = ainda lendo; null = não configurada
    const [salvarEm, setSalvarEm] = useState(undefined);
    const [gerado, setGerado] = useState(null);

    useEffect(() => {
        get("/reports/batimento-getnet/pasta")
            .then(res => setSalvarEm(res?.salvarEm || null))
            .catch(() => setSalvarEm(null));
    }, []);

    const handleExportar = () => {
        setLoading(true);
        
        // Data local (toISOString é UTC e virava o dia seguinte depois das 21h)
        const hoje = new Date();
        const dataStr = `${hoje.getFullYear()}${String(hoje.getMonth() + 1).padStart(2, "0")}${String(hoje.getDate()).padStart(2, "0")}`;
        const fileName = `Batimento - Agenda Negativa_${dataStr}.xlsx`;

        const filtros = {}; // A query do backend já traz as regras hardcoded conforme a regra de negócio

        postFile("/reports/export", {
            fonteDados: "batimentoGetNet",
            filtros: filtros,
            dateFormat: "dd/mm/yyyy",
            valueFormat: "R$ #,##0.00"
        }, fileName)
            .then((res) => {
                setGerado(res || null);
                if (res?.salvoEm) {
                    successAlert(`Batimento gerado e salvo em <b>${escaparHtml(res.salvoEm)}</b>.`);
                } else if (res?.erroPasta) {
                    warningAlert(escaparHtml(res.erroPasta));
                } else {
                    successAlert("Batimento gerado e baixado.");
                }
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                errorAlert(err?.message || "Erro ao exportar Arquivo de Batimento.");
                setLoading(false);
            });
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Card
                    variant="outlined"
                    sx={{
                        p: 2,
                        mb: 2,
                        background: darkMode ? ESCURO.cartao : "#fff",
                        borderColor: darkMode ? ESCURO.divisoria : "#ddd",
                    }}
                >
                    <MDBox p={1} pb={2} display="flex" justifyContent="space-between" alignItems="center">
                        <MDTypography variant="h6" color={darkMode ? "white" : "dark"}>
                            Exportar Arquivo de Batimento - Getnet
                        </MDTypography>
                    </MDBox>

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <MDTypography variant="caption" fontWeight="bold" color="text" sx={{ px: 1, pb: 0.3, display: "block" }}>
                                Cliente Associado
                            </MDTypography>
                            <MDInput 
                                fullWidth 
                                value="Getnet" 
                                disabled 
                               
                            />
                        </Grid>

                        <Grid item xs={12} display="flex" justifyContent="flex-end" gap={1.5} pt={1.5}>
                            <MDButton 
                                variant="contained" 
                                color="info" 
                                size="small"
                                onClick={handleExportar}
                                disabled={loading}
                            >
                                {loading ? "Gerando..." : salvarEm
                                    ? <><Icon sx={{ mr: 1 }}>save</Icon> Gerar e Salvar (Excel)</>
                                    : <><Icon sx={{ mr: 1 }}>download</Icon> Gerar e Baixar (Excel)</>}
                            </MDButton>
                        </Grid>

                        {salvarEm !== undefined && (
                            <Grid item xs={12}>
                                {gerado?.salvoEm ? (
                                    <Alert severity="success" sx={{ fontSize: "0.8rem" }}>
                                        Arquivo salvo em <b>{gerado.salvoEm}</b>.
                                    </Alert>
                                ) : gerado?.erroPasta ? (
                                    <Alert severity="warning" sx={{ fontSize: "0.8rem" }}>{gerado.erroPasta}</Alert>
                                ) : salvarEm ? (
                                    <Alert severity="info" sx={{ fontSize: "0.8rem" }}>
                                        Ao gerar, o arquivo será salvo em <b>{salvarEm}</b> (não é baixado no computador).
                                    </Alert>
                                ) : (
                                    <Alert severity="warning" sx={{ fontSize: "0.8rem" }}>
                                        A pasta do Batimento Getnet não está configurada (Parametrização do Sistema &gt; Pastas e
                                        Arquivos): ao gerar, o arquivo só será baixado.
                                    </Alert>
                                )}
                            </Grid>
                        )}
                    </Grid>

                    <MDBox mt={3} p={2} sx={{ backgroundColor: darkMode ? ESCURO.cartao : "#f8f9fa", borderRadius: 2 }}>
                        <MDTypography variant="subtitle2" color="text" fontWeight="medium" mb={1}>
                            Regras de Extração (Automáticas):
                        </MDTypography>
                        <MDTypography variant="caption" color="text" display="block">
                            • Apenas casos com Negociação em Andamento.
                        </MDTypography>
                        <MDTypography variant="caption" color="text" display="block">
                            • Apenas casos com Acordo Cancelado e não pagos após 10 dias de atraso.
                        </MDTypography>
                        <MDTypography variant="caption" color="text" display="block">
                            • Apenas casos em Tratativas onde a data de devolução passou de 40 dias.
                        </MDTypography>
                    </MDBox>
                </Card>
            </Grid>
        </Grid>
    );
}
